export default {"src":"/_next/static/media/YGGJ3.73c7687c.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};